// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-alpine {
  --ag-borders: none;
  --ag-borders-secondary: solid 1px;
  --ag-header-background-color: #0b203b;
  --ag-background-color: #f5f5f5;
  --ag-header-foreground-color: var(--color-white);
  --ag-row-height: 30px;
  --ag-odd-row-background-color: #f5f5f5;
}

.ag-theme-quartz {
  --ag-header-background-color: #0b203b;
  --ag-background-color: #f5f5f5;
  --ag-header-foreground-color: var(--color-white);
  --ag-row-height: 48px;
  --ag-odd-row-background-color: #fff;
  --ag-header-height: 48px;
  --ag-borders: none;
  --ag-borders-secondary: solid 1px;
  --ag-border-color: #b3b3b3;
}

.ag-theme-alpine .ag-paging-panel {
  background: var(--color-bg-page) !important; /* matches the page, bar disappears */
  border-top: none !important;
  color: var(--color-text-dark);
}

.ag-theme-alpine .ag-paging-button .ag-icon {
  color: var(--color-primary-green); /* gold arrows */
}

.ag-theme-alpine .ag-root-wrapper-body {
  border: 1px solid #b3b3b3;
}

.ag-theme-alpine .ag-root-wrapper-body {
  border: 1px solid #b3b3b3;
}

.ag-theme-alpine .ag-root-wrapper {
  border: none !important; /* removes the box around rows + pagination */
}

.ag-pinned-left-header {
  z-index: 3;
  background-color: #0b203b;
  overflow: visible;
}

.ag-theme-alpine .ag-ltr .ag-cell {
  border-right: 1px solid #b3b3b3 !important;
  border-bottom: 1px solid #b3b3b3 !important;
}

.ag-cell.ag-cell-not-inline-editing.ag-cell-last-left-pinned {
  border-right: 2px solid #b3b3b3 !important;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before,
.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after,
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  left: -25px !important;
}

.ag-row {
  cursor: pointer;
}

.ag-header {
  min-height: 0px;
}

.ag-header-row {
  height: 48px !important;
}

.ag-header-row.ag-header-row-floating-filter {
  height: 48px !important;
}

.ag-header-cell-menu-button:hover {
  color: red !important;
}

.ag-header-cell {
  border-right: 1px solid #b3b3b3;
  border: none;
}

.ag-center-cols-container {
  margin: 0px !important;
}

.ag-theme-alpine .ag-root-wrapper {
  font-weight: bold;
  border-bottom: 1px solid #b3b3b3;
  border-left: 1px solid #b3b3b3;
}

.ag-header-cell .ag-icon {
  color: white;
}

.ag-theme-alpine .ag-ltr .ag-cell {
  font-weight: 500;
}

.ag-theme-alpine .ag-row {
  border-left: 1px solid #b3b3b3 !important;
}

.ag-menu {
  margin-top: 30px !important;
  z-index: 9999;
}

.ag-theme-alpine .ag-menu-header {
  display: none !important;
}

.ag-header-cell-menu-button {
  opacity: 1 !important;
}

.ag-theme-alpine .ag-header-cell-menu-button {
  opacity: 1 !important;
}

.ag-icon-filter {
  color: #1562ba !important;
}

.ag-theme-alpine .ag-header-cell,
.ag-theme-alpine .ag-header-group-cell {
  padding: 0 0.5rem;
}

.ag-theme-alpine .ag-ltr .ag-floating-filter-button {
  margin-left: 5px !important;
}

#floatingActiveFilter {
  align-items: center;
  display: flex;
  width: 100%;
}

.custom-tooltip {
  width: 150px;
  height: 70px;
  border: 1px solid cornflowerblue;
  overflow: hidden;
  position: absolute;
  background-color: white;
}

.covering_store:before {
  font-style: normal;
  font-size: 1.15rem;
  content: "\\f0c8";
  font-family: "Font Awesome 6 Free";
  font-weight: 400;
}

.covering_store_checked:before {
  font-style: normal;
  font-size: 1.15rem;
  color: var(--color-primary-orange);
  content: "\\f14a";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
}

.ag-theme-alpine .ag-ltr .ag-header-select-all {
  margin-left: 3px; /*11px; */
}

.ag-theme-alpine .ag-header-cell,
.ag-theme-alpine .ag-header-group-cell {
  overflow: visible;
}

#react-select-5-listbox {
  z-index: 11 !important;
}

.ag-floating-filter-full-body {
  overflow: visible;
}

.ag-header-container {
  z-index: 2;
}

.ag-menu.ag-ltr.ag-popup-child {
  z-index: 2;
}

.css-4ljt47-MenuList {
  overflow: auto !important;
}

.css-319lph-ValueContainer,
.css-319lph-ValueContainer div {
  overflow: hidden !important;
}

.ag-header .ag-header-cell-label {
  overflow: hidden;
}

.input.form-control.form-select.checkboxDropdownFilter {
  padding: 3px 28px 2px 3px;
}

.ag-selection-checkbox {
  height: 25px !important;
}

.ag-theme-alpine .ag-row-even {
  background-color: #F3F8FF !important;
  border-color: #efeff8 !important;
}

.ag-theme-alpine .ag-row-odd {
  background-color: #fff !important;
}

.ag-theme-alpine .ag-row-even .ag-cell {
  border-color: #efeff8 !important;
}

.ag-theme-alpine .ag-row-odd .ag-cell {
  border-color: #fff !important;
}

.ag-theme-alpine .ag-row {
  border-left: 1px solid #b3b3b3 !important;
}

.ag-theme-alpine .ag-cell {
  padding: 0 0.5rem;
}

.greyOutIcon:before {
  font-style: normal;
  font-size: 1rem;
  background-color: #9d9d9d;
  color: #ffffff;
  border-radius: 3px;
  padding: 0px 3px;
  content: "\\f00d";
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
}

.ag-theme-alpine .not-current-row {
  background-color: #ffe6ef !important;
}

.ag-theme-quartz .ag-side-bar {
  background-color: #fff;
  border-left: 1px solid #b3b3b3;
}

.ag-theme-quartz .ag-tool-panel-wrapper {
  background-color: #fff;
}

.ag-theme-quartz .ag-filter-toolpanel-header {
  display: block !important;
  background-color: var(--color-primary-orange);
  color: white;
  padding: 10px;
  font-weight: bold;
  font-size: 14px;
}

.ag-theme-quartz .ag-filter-toolpanel-instance {
  margin-bottom: 5px;
  border-bottom: 1px solid #e0e0e0;
}

.ag-theme-quartz .ag-filter-toolpanel-instance-header {
  background-color: #f5f5f5;
  padding: 8px 10px;
  cursor: pointer;
  font-weight: 500;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}

.ag-theme-quartz .ag-filter-toolpanel-instance-header:hover {
  background-color: #e8e8e8;
}

.ag-theme-quartz .ag-column-panel {
  background-color: #fff;
}

.ag-theme-quartz .ag-side-button {
  background-color: var(--color-primary-orange);
  color: white;
  border: none;
}

.ag-theme-quartz .ag-side-button:hover {
  background-color: #666666;
}

.ag-theme-quartz .ag-selected .ag-side-button {
  background-color: #555555;
}

#server-side-grid-wrapper {
  --ag-alpine-active-color: var(--color-primary-green);
}
#server-side-grid-wrapper .ag-side-buttons {
  background: var(--color-white) !important;
}
#server-side-grid-wrapper .ag-side-buttons .ag-side-button-icon-wrapper .ag-icon-filter,
#server-side-grid-wrapper .ag-side-buttons .ag-side-button-icon-wrapper .ag-icon-columns {
  color: var(--color-primary-green) !important;
  font-weight: bolder !important;
}
#server-side-grid-wrapper .ag-side-buttons .ag-side-button-icon-wrapper .ag-side-button-label:hover {
  color: var(--color-primary-green) !important;
  font-weight: bolder !important;
}
#server-side-grid-wrapper .ag-icon-filter {
  color: var(--color-primary-green) !important;
  font-weight: bolder !important;
}
#server-side-grid-wrapper .ag-header-cell-comp-wrapper .ag-header-cell-text {
  color: #FFF !important;
}
#server-side-grid-wrapper .ag-header-cell-comp-wrapper .ag-header-cell-menu-button:hover {
  color: var(--color-primary-green) !important;
}

.table-actions-row {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
  flex-wrap: nowrap;
}

@media (max-width: 768px) {
  .table-actions-row {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-actions-row .btn {
    flex: 0 0 auto;
    min-width: unset !important;
    width: auto !important;
    padding: 6px 10px !important;
    font-size: 13px !important;
    white-space: nowrap;
  }
}
.ag-filter-toolpanel-header,
.ag-filter-toolpanel-group-title,
.ag-column-select-column-label,
.ag-column-select-header {
  color: var(--color-text-dark) !important;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/listview/TableStyle.scss"],"names":[],"mappings":"AAMA;EACE,kBAAA;EACA,iCAAA;EACA,qCAAA;EACA,8BAAA;EACA,gDAAA;EACA,qBAAA;EACA,sCAAA;AAHF;;AAOA;EACE,qCAAA;EACA,8BAAA;EACA,gDAAA;EACA,qBAAA;EACA,mCAAA;EACA,wBAAA;EACA,kBAAA;EACA,iCAAA;EACA,0BAAA;AAJF;;AAMA;EACE,2CAAA,EAAA,qCAAA;EACA,2BAAA;EACA,6BAAA;AAHF;;AAMA;EACE,iCAAA,EAAA,gBAAA;AAHF;;AAKA;EACE,yBAAA;AAFF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,uBAAA,EAAA,6CAAA;AADF;;AAGA;EACE,UAAA;EACA,yBAAA;EACA,iBAAA;AAAF;;AAGA;EAEE,0CAAA;EACA,2CAAA;AADF;;AAIA;EACE,0CAAA;AADF;;AAIA;;;;EAIE,sBAAA;AADF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,uBAAA;AAFF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,+BAAA;EACA,YAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAOA;EACE,iBAAA;EACA,gCAAA;EACA,8BAAA;AAJF;;AAOA;EACE,YAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAYA;EACE,yCAAA;AATF;;AAcA;EACE,2BAAA;EACA,aAAA;AAXF;;AAcA;EACE,wBAAA;AAXF;;AAcA;EACE,qBAAA;AAXF;;AAcA;EACE,qBAAA;AAXF;;AAcA;EACE,yBAAA;AAXF;;AAcA;;EAEE,iBAAA;AAXF;;AAcA;EACE,2BAAA;AAXF;;AAeA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;AAZF;;AAeA;EACE,YAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,kCAAA;EACA,gBAAA;AAbF;;AAkBA;EACE,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AAfF;;AAmBA;EACE,gBAAA,EAAA,SAAA;AAhBF;;AAqBA;;EAEE,iBAAA;AAlBF;;AAqBA;EACE,sBAAA;AAlBF;;AAqBA;EACE,iBAAA;AAlBF;;AA8BA;EACE,UAAA;AA3BF;;AA8BA;EACE,UAAA;AA3BF;;AA8BA;EACE,yBAAA;AA3BF;;AA8BA;;EAEE,2BAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,yBAAA;AA3BF;;AA+BA;EACE,uBAAA;AA5BF;;AA0CA;EACE,oCAAA;EACA,gCAAA;AAvCF;;AA0CA;EACE,iCAAA;AAvCF;;AA0CA;EACE,gCAAA;AAvCF;;AAyCA;EACE,6BAAA;AAtCF;;AAyCA;EACE,yCAAA;AAtCF;;AAwCA;EACE,iBAAA;AArCF;;AAwCA;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;AArCF;;AAwCA;EACE,oCAAA;AArCF;;AA2CA;EACE,sBAAA;EACA,8BAAA;AAxCF;;AA4CA;EACE,sBAAA;AAzCF;;AA6CA;EACE,yBAAA;EACA,6CAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,gCAAA;AA1CF;;AA6CA;EACE,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,8BAAA;AA1CF;;AA6CA;EACE,yBAAA;AA1CF;;AA8CA;EACE,sBAAA;AA3CF;;AA+CA;EACE,6CAAA;EACA,YAAA;EACA,YAAA;AA5CF;;AA+CA;EACE,yBAAA;AA5CF;;AA+CA;EACE,yBAAA;AA5CF;;AAmDA;EAEE,oDAAA;AAjDF;AA0DE;EACE,yCAAA;AAxDJ;AA2DE;;EAEE,4CAAA;EACA,8BAAA;AAzDJ;AA4DE;EACE,4CAAA;EACA,8BAAA;AA1DJ;AA6DE;EACE,4CAAA;EACA,8BAAA;AA3DJ;AA8DE;EACE,sBAAA;AA5DJ;AAgEA;EACE,4CAAA;AA9DF;;AAqFA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AAlFF;;AAqFA;EACE;IACE,gBAAA;IACA,iCAAA;EAlFF;EAqFA;IACE,cAAA;IACA,2BAAA;IACA,sBAAA;IACA,4BAAA;IACA,0BAAA;IACA,mBAAA;EAnFF;AACF;AAqFE;;;;EAIE,wCAAA;AAnFJ","sourcesContent":["@import \"~ag-grid-community/dist/styles/ag-grid.css\";\n@import \"~ag-grid-community/dist/styles/ag-theme-alpine.css\";\n// https://www.ag-grid.com/react-data-grid/themes-customising/\n\n\n// Alpine theme (existing tables) - v31 uses CSS variables\n.ag-theme-alpine {\n  --ag-borders: none;\n  --ag-borders-secondary: solid 1px;\n  --ag-header-background-color: #0b203b;\n  --ag-background-color: #f5f5f5;\n  --ag-header-foreground-color: var(--color-white);\n  --ag-row-height: 30px;\n  --ag-odd-row-background-color: #f5f5f5;\n}\n\n// Quartz theme (Material Design icons) - v31+\n.ag-theme-quartz {\n  --ag-header-background-color: #0b203b;\n  --ag-background-color: #f5f5f5;\n  --ag-header-foreground-color: var(--color-white);\n  --ag-row-height: 48px;\n  --ag-odd-row-background-color: #fff;\n  --ag-header-height: 48px;\n  --ag-borders: none;\n  --ag-borders-secondary: solid 1px;\n  --ag-border-color: #b3b3b3;\n}\n.ag-theme-alpine .ag-paging-panel {\n  background: var(--color-bg-page) !important;   /* matches the page, bar disappears */\n  border-top: none !important;\n  color: var(--color-text-dark);\n}\n\n.ag-theme-alpine .ag-paging-button .ag-icon {\n  color: var(--color-primary-green);             /* gold arrows */\n}\n.ag-theme-alpine .ag-root-wrapper-body {\n  border: 1px solid #b3b3b3;\n}\n.ag-theme-alpine .ag-root-wrapper-body {\n  border: 1px solid #b3b3b3;\n}\n\n.ag-theme-alpine .ag-root-wrapper {\n  border: none !important;       /* removes the box around rows + pagination */\n}\n.ag-pinned-left-header {\n  z-index: 3;\n  background-color: #0b203b;\n  overflow: visible;\n}\n\n.ag-theme-alpine .ag-ltr .ag-cell {\n  // border: 1px solid #b3b3b3 !important;\n  border-right: 1px solid #b3b3b3 !important;\n  border-bottom: 1px solid #b3b3b3 !important;\n}\n\n.ag-cell.ag-cell-not-inline-editing.ag-cell-last-left-pinned {\n  border-right: 2px solid #b3b3b3 !important;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before,\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after,\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  left: -25px !important;\n}\n\n\n.ag-row {\n  cursor: pointer;\n}\n\n.ag-header {\n  min-height: 0px;\n}\n\n.ag-header-row {\n  height: 48px !important; // Increased for better header visibility\n}\n\n// Floating filter row\n.ag-header-row.ag-header-row-floating-filter {\n  height: 48px !important; // Height for filter row\n}\n\n.ag-header-cell-menu-button:hover{\n  color:red !important;\n}\n\n.ag-header-cell {\n  border-right: 1px solid #b3b3b3;\n  border: none;\n}\n\n.ag-center-cols-container {\n  margin: 0px !important;\n  // width:100% !important\n}\n\n.ag-theme-alpine .ag-root-wrapper {\n  font-weight: bold;\n  border-bottom: 1px solid #b3b3b3;\n  border-left: 1px solid #b3b3b3;\n}\n\n.ag-header-cell .ag-icon {\n  color: white;\n}\n\n.ag-theme-alpine .ag-ltr .ag-cell {\n  font-weight: 500;\n  // word-break:break-word; //for text wrapping\n  // white-space: pre-wrap; //for text wrapping\n  // line-height: normal !important; //for text wrapping\n  // padding-bottom: 9px; //for text wrapping\n  // padding-top:5px;\n}\n\n.ag-theme-alpine .ag-row {\n  border-left: 1px solid #b3b3b3 !important;\n  //height:0px; // for text wrapping\n}\n\n// Filter menu positioning - push it down from header\n.ag-menu {\n  margin-top: 30px !important; \n  z-index:9999\n}\n\n.ag-theme-alpine .ag-menu-header {\n  display: none !important;\n}\n// Always show the menu icon (three lines), not just on hover\n.ag-header-cell-menu-button {\n  opacity: 1 !important; // Always visible\n}\n\n.ag-theme-alpine .ag-header-cell-menu-button {\n  opacity: 1 !important; // Always visible, override theme\n}\n\n.ag-icon-filter {\n  color:#1562ba !important\n}\n\n.ag-theme-alpine .ag-header-cell,\n.ag-theme-alpine .ag-header-group-cell {\n  padding: 0 0.5rem;\n}\n\n.ag-theme-alpine .ag-ltr .ag-floating-filter-button {\n  margin-left: 5px !important;\n}\n\n\n#floatingActiveFilter {\n  align-items: center;\n  display: flex;\n  width: 100%;\n}\n\n.custom-tooltip {\n  width: 150px;\n  height: 70px;\n  border: 1px solid cornflowerblue;\n  overflow: hidden;\n  position: absolute;\n  background-color: white;\n}\n\n.covering_store:before {\n  font-style: normal;\n  font-size: 1.15rem;\n  //color:red;\n  content: \"\\f0c8\";\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 400;\n}\n\n\n\n.covering_store_checked:before {\n  font-style: normal;\n  font-size: 1.15rem;\n  color: var(--color-primary-orange);\n  content: \"\\f14a\";\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n}\n\n\n.ag-theme-alpine .ag-ltr .ag-header-select-all {\n  margin-left: 3px;  /*11px; */\n  // margin-top: 76px;\n  // z-index: 10;\n}\n\n.ag-theme-alpine .ag-header-cell,\n.ag-theme-alpine .ag-header-group-cell {\n  overflow: visible;\n}\n\n#react-select-5-listbox {\n  z-index: 11 !important;\n}\n\n.ag-floating-filter-full-body {\n  overflow: visible;\n}\n\n// Remove overflow visible from header to allow horizontal scroll sync\n// .ag-header {\n//   overflow: visible;\n// }\n\n// .ag-header-viewport {\n//   overflow: visible;\n// }\n\n.ag-header-container {\n  z-index: 2;\n}\n\n.ag-menu.ag-ltr.ag-popup-child {\n  z-index: 2;\n}\n\n.css-4ljt47-MenuList {\n  overflow: auto !important;\n}\n\n.css-319lph-ValueContainer,\n.css-319lph-ValueContainer div {\n  overflow: hidden !important;\n}\n\n.ag-header .ag-header-cell-label {\n  overflow: hidden;\n}\n\n.input.form-control.form-select.checkboxDropdownFilter {\n  padding: 3px 28px 2px 3px;\n}\n\n//for text wrapping\n.ag-selection-checkbox{\n  height: 25px !important;;\n}\n\n// .ag-body-viewport::-webkit-scrollbar {\n//   width: 7px;\n//   background-color: #e0e0e0;\n// }\n\n// .ag-body-viewport::-webkit-scrollbar-thumb {\n//   background-color: #3e4957;\n//   border-radius: 3px;\n\n// }\n\n.ag-theme-alpine .ag-row-even {\n  background-color: #F3F8FF !important;\n  border-color:#efeff8 !important;\n}\n\n.ag-theme-alpine .ag-row-odd {\n  background-color: #fff !important;\n  \n}\n.ag-theme-alpine .ag-row-even .ag-cell {\n  border-color:#efeff8 !important;\n}\n.ag-theme-alpine .ag-row-odd .ag-cell {\n  border-color:#fff !important;\n}\n\n.ag-theme-alpine .ag-row {\n  border-left: 1px solid #b3b3b3 !important;\n}\n.ag-theme-alpine .ag-cell {\n  padding:0 0.5rem;\n}\n\n.greyOutIcon:before {\n  font-style: normal;\n  font-size: 1rem;\n  background-color: #9d9d9d;\n  color: #ffffff;\n  border-radius: 3px;\n  padding: 0px 3px;\n  content: \"\\f00d\";\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n}\n\n.ag-theme-alpine .not-current-row {\n  background-color: #ffe6ef !important;\n}\n\n// ===== Sidebar Styling for Quartz Theme =====\n\n// Sidebar container\n.ag-theme-quartz .ag-side-bar {\n  background-color: #fff;\n  border-left: 1px solid #b3b3b3;\n}\n\n// Tool panel wrapper\n.ag-theme-quartz .ag-tool-panel-wrapper {\n  background-color: #fff;\n}\n\n// Filter toolpanel styling\n.ag-theme-quartz .ag-filter-toolpanel-header {\n  display: block !important;\n  background-color: var(--color-primary-orange);\n  color: white;\n  padding: 10px;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.ag-theme-quartz .ag-filter-toolpanel-instance {\n  margin-bottom: 5px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.ag-theme-quartz .ag-filter-toolpanel-instance-header {\n  background-color: #f5f5f5;\n  padding: 8px 10px;\n  cursor: pointer;\n  font-weight: 500;\n  display: flex !important;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ag-theme-quartz .ag-filter-toolpanel-instance-header:hover {\n  background-color: #e8e8e8;\n}\n\n// Column panel styling\n.ag-theme-quartz .ag-column-panel {\n  background-color: #fff;\n}\n\n// Sidebar buttons\n.ag-theme-quartz .ag-side-button {\n  background-color: var(--color-primary-orange);\n  color: white;\n  border: none;\n}\n\n.ag-theme-quartz .ag-side-button:hover {\n  background-color: #666666;\n}\n\n.ag-theme-quartz .ag-selected .ag-side-button {\n  background-color: #555555;\n}\n\n// ===== ServerSideGrid Custom Styles =====\n// Use #server-side-grid-wrapper to scope styles only to ServerSideGrid component\n// This allows custom styling without affecting existing client-side AG Grid tables\n\n#server-side-grid-wrapper {\n  // Override AG Grid CSS variables for ServerSideGrid only\n  --ag-alpine-active-color: var(--color-primary-green);\n\n  // You can add more custom CSS variable overrides here:\n  // --ag-header-background-color: #888888;\n  // --ag-background-color: #f5f5f5;\n  // --ag-row-height: 48px;\n  // --ag-border-color: #b3b3b3;\n\n  // Sidebar toolpanel styling\n  .ag-side-buttons {\n    background: var(--color-white) !important;\n  }\n\n  .ag-side-buttons .ag-side-button-icon-wrapper .ag-icon-filter,\n  .ag-side-buttons .ag-side-button-icon-wrapper .ag-icon-columns {\n    color:var(--color-primary-green) !important;\n    font-weight: bolder !important;\n  }\n\n  .ag-side-buttons .ag-side-button-icon-wrapper .ag-side-button-label:hover {\n    color: var(--color-primary-green) !important;\n    font-weight: bolder !important;\n  }\n\n  .ag-icon-filter {\n    color:var(--color-primary-green) !important;\n    font-weight: bolder !important;\n  }\n  \n  .ag-header-cell-comp-wrapper .ag-header-cell-text{\n    color:#FFF !important\n  }\n  \n  \n.ag-header-cell-comp-wrapper .ag-header-cell-menu-button:hover{\n  color:var(--color-primary-green) !important;\n}\n\n  // Custom styles for alpine theme in ServerSideGrid\n  // .ag-theme-alpine {\n  //   // Add custom alpine theme overrides here\n  // }\n\n  // Custom styles for quartz theme in ServerSideGrid\n  // .ag-theme-quartz {\n  //   // Add custom quartz theme overrides here\n  // }\n\n  // Custom cell styles for ServerSideGrid\n  // .ag-cell {\n  //   // Add custom cell styles here\n  // }\n\n  // Custom header styles for ServerSideGrid\n  // .ag-header-row {\n  //   // Add custom header styles here\n  // }\n}\n.table-actions-row {\n  display: flex;\n  gap: 6px;\n  margin-bottom: 6px;\n  flex-wrap: nowrap;\n}\n\n@media (max-width: 768px) {\n  .table-actions-row {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .table-actions-row .btn {\n    flex: 0 0 auto;\n    min-width: unset !important;\n    width: auto !important;\n    padding: 6px 10px !important;\n    font-size: 13px !important;\n    white-space: nowrap;\n  }\n}\n  .ag-filter-toolpanel-header,\n  .ag-filter-toolpanel-group-title,\n  .ag-column-select-column-label,\n  .ag-column-select-header {\n    color: var(--color-text-dark) !important;\n  }\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
